import { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import Form_Header from "../../../common/form-header/Form_Header";
import "./Create_Step3.css";
import Preview_Modal from "../../../common/common-modal/preview-modal/Preview_Modal";

const Create_Step3 = ({ step, totalSteps, setStep }) => {
  const [showDocs, setShowDocs] = useState(false);
  const [selectedType, setSelectedType] = useState("");

  // ----- Multiple files -----
  const fileRefs = {
    shopAct: useRef(null),
    gst: useRef(null),
    salesTax: useRef(null),
    itr: useRef(null),
  };

  const [files, setFiles] = useState({
    shopAct: null,
    gst: null,
    salesTax: null,
    itr: null,
  });

  // ----- Single file -----
  const singleFileRef = useRef(null);
  const [singleFile, setSingleFile] = useState(null);

  // ----- Modal -----
  const [modalShow, setModalShow] = useState(false);
  const [modalFile, setModalFile] = useState(null);

  // ----- Handlers -----
  const handleFileChange = (type, e) => {
    const file = e.target.files[0];
    if (file) {
      setFiles((prev) => ({
        ...prev,
        [type]: {
          file,
          name: file.name,
          preview: URL.createObjectURL(file),
        },
      }));
    }
  };

  const handleSingleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSingleFile({
        file,
        name: file.name,
        preview: URL.createObjectURL(file),
      });
    }
  };

  const handlePreview = (file) => {
    setModalFile(file);
    setModalShow(true);
  };

  const handleFileButtonClick = (type) => {
    if (files[type]?.preview) {
      handlePreview(files[type]);
    } else {
      fileRefs[type].current.click();
    }
  };

  const handleSingleButtonClick = () => {
    if (singleFile?.preview) {
      handlePreview(singleFile);
    } else {
      singleFileRef.current.click();
    }
  };

  // ---------------- DOCUMENT PAGE ----------------
  if (showDocs) {
    return (
      <section className="step3_wrapper step1_wrapper">
        <Form_Header
          title="Legal Proofs & Compliance"
          subtitle=""
          step={3}
          totalSteps={6}
        />
        <div className="container mt-4">
          <div className="doc_header">
            <h5 className="doc_title">{selectedType}</h5>
            <span className="doc_info">
              Any 2 of the following: Shop Act License, GST Certificate, Sales
              Tax/Service Tax Registration, or complete ITR.
            </span>
          </div>
          <h5 className="doc_back" onClick={() => setShowDocs(false)}>
            Back
          </h5>

          <div className="row mt-4">
            {[
              { label: "Shop Act License", key: "shopAct" },
              { label: "GST Certificate", key: "gst" },
              { label: "Sales Tax/Service Tax Registration", key: "salesTax" },
              { label: "ITR", key: "itr" },
            ].map((item) => (
              <div className="col-lg-6 mb-4" key={item.key}>
                <Form.Group>
                  <Form.Label>{item.label}</Form.Label>

                  <div className="file_upload_wrapper">
                    <span className="file_placeholder">
                      {files[item.key] ? files[item.key].name : "No File Uploaded"}
                    </span>

                    <div
                      className="upload_btn"
                      onClick={() => handleFileButtonClick(item.key)}
                    >
                      <Common_Btn
                        btnText={files[item.key] ? "Preview" : "Upload file"}
                      />
                    </div>

                    <input
                      ref={fileRefs[item.key]}
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={(e) => handleFileChange(item.key, e)}
                    />
                  </div>
                </Form.Group>
              </div>
            ))}
          </div>

          <div className="text-center mt-4 form_btn_holder">
            <Common_Btn btnText={"Done"} onClick={() => setShowDocs(false)} />
          </div>
        </div>

        {/* Document Modal */}
        <Preview_Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          file={modalFile}
          onUploadNew={() => {
            if (modalFile === singleFile) {
              singleFileRef.current.click();
            } else {
              const key = Object.keys(files).find((k) => files[k] === modalFile);
              fileRefs[key].current.click();
            }
          }}
          onDelete={() => {
            if (modalFile === singleFile) {
              setSingleFile(null);
            } else {
              const key = Object.keys(files).find((k) => files[k] === modalFile);
              setFiles((prev) => ({ ...prev, [key]: null }));
            }
            setModalShow(false);
          }}
        />
      </section>
    );
  }

  // ---------------- MAIN FORM ----------------
  return (
    <section className="step3_wrapper step1_wrapper">
      <Form_Header
        title="Legal Proofs & Compliance"
        subtitle=""
        step={3}
        totalSteps={6}
      />

      <div className="container">
        <Form className="auth_form">
          <div className="row">
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>GST Number</Form.Label>
                <Form.Control type="text" placeholder="Enter GST Number" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>PAN Card Number</Form.Label>
                <Form.Control type="text" placeholder="Enter PAN Card Number" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Fire Safety Certificate / NOC</Form.Label>

                <div className="file_upload_wrapper">
                  <span className="file_placeholder">
                    {singleFile ? singleFile.name : "No File Uploaded"}
                  </span>

                  <div className="upload_btn" onClick={handleSingleButtonClick}>
                    <Common_Btn btnText={singleFile ? "Preview" : "Upload file"} />
                  </div>

                  <input
                    ref={singleFileRef}
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleSingleFileChange}
                  />
                </div>
              </Form.Group>
            </div>

            <div className="col-lg-12">
              <Form.Label>
                Proof of Constitution (Select relevant one)
              </Form.Label>
            </div>

            {[
              "Sole Proprietorship",
              "Partnership Firm/LLP",
              "Private Limited Company",
            ].map((item, index) => (
              <div
                className="col-lg-6 mb-3"
                key={index}
                onChange={() => {
                  setSelectedType(item);
                  setShowDocs(true);
                }}
              >
                <Form.Check
                  type="radio"
                  name="constitution"
                  id={item}
                  label={
                    <span className="radio_card">
                      <span className="radio_circle"></span>
                      {item}
                    </span>
                  }
                  className="radio_card_wrapper"
                  onChange={() => {
                    setSelectedType(item);
                    setShowDocs(true);
                  }}
                />
              </div>
            ))}
          </div>
        </Form>

        <div className="form_btn_holder">
          <White_Btn btnText={"Back"} onClick={() => setStep(2)} />
          <Common_Btn btnText={"Next"} onClick={() => setStep(4)} />
        </div>

        {/* Document Modal */}
        <Preview_Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          file={modalFile}
          onUploadNew={() => {
            if (modalFile === singleFile) {
              singleFileRef.current.click();
            } else {
              const key = Object.keys(files).find((k) => files[k] === modalFile);
              fileRefs[key].current.click();
            }
          }}
          onDelete={() => {
            if (modalFile === singleFile) {
              setSingleFile(null);
            } else {
              const key = Object.keys(files).find((k) => files[k] === modalFile);
              setFiles((prev) => ({ ...prev, [key]: null }));
            }
            setModalShow(false);
          }}
        />
      </div>
    </section>
  );
};

export default Create_Step3;
